var map = {
  "./asset-hyperlink.json": "9907",
  "./blockquote.json": "8018",
  "./document.json": "2690",
  "./embedded-asset-block.json": "9002",
  "./embedded-entry-block.json": "6624",
  "./embedded-entry-inline.json": "5571",
  "./embedded-resource-block.json": "8138",
  "./embedded-resource-inline.json": "8962",
  "./entry-hyperlink.json": "4172",
  "./heading-1.json": "6745",
  "./heading-2.json": "4133",
  "./heading-3.json": "9830",
  "./heading-4.json": "8171",
  "./heading-5.json": "8009",
  "./heading-6.json": "9403",
  "./hr.json": "1708",
  "./hyperlink.json": "2641",
  "./list-item.json": "3795",
  "./ordered-list.json": "6119",
  "./paragraph.json": "456",
  "./resource-hyperlink.json": "2659",
  "./table-cell.json": "5811",
  "./table-header-cell.json": "6200",
  "./table-row.json": "1117",
  "./table.json": "2294",
  "./text.json": "87",
  "./unordered-list.json": "6208"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2737;
